import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import Popup from "../../../../components/common/model/Popup";
import CustomButton from "../../../../components/common/button/CustomButton";
import FormField from "../../../../components/common/FormField";
import { SITE_FILTER_FIELDS } from "./siteFields";

interface SiteFilterData {
  siteType: string;
  storageType: string;
}

interface ManageSiteFilterProps {
  open: boolean;
  onHide: () => void;
  title: string;
  filterData: SiteFilterData;
  onApply: (data: SiteFilterData) => void;
  onClear: () => void;
}



const ManageSiteFilter: React.FC<ManageSiteFilterProps> = ({
  open,
  onHide,
  title,
  filterData,
  onApply,
  onClear,
}) => {
  const [formData, setFormData] = useState<SiteFilterData>({
    siteType: "",
    storageType: "",
  });

  useEffect(() => {
    if (open) {
      setFormData({
        siteType: filterData?.siteType || "",
        storageType: filterData?.storageType || "",
      });
    }
  }, [open, filterData]);

  const onChangeAction = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { id, value } = event.target;

    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const hideHandler = () => {
    onHide();
  };

  const clearHandler = () => {
    const clearedData: SiteFilterData = {
      siteType: "",
      storageType: "",
    };

    setFormData(clearedData);

    // Send clear action to SiteList
    onClear();

    onHide();
  };

  const submitHandler = () => {
    // Send selected filters to SiteList
    onApply(formData);

    onHide();
  };

  return (
    <Popup
      open={open}
      title={title}
      onHide={hideHandler}
      fullWidth
      maxWidth="sm"
      popupBg="#fff"
      footer={
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            marginTop:'16px'
          }}
        >
          <CustomButton
            style={{
              padding: "10px 30px",
              height: "36px",
            }}
            variant="outlined"
            title="Clear"
            onClick={clearHandler}
          />

          <CustomButton
            style={{
              padding: "10px 30px",
              height: "36px",
            }}
            variant="outlined"
            title="Cancel"
            onClick={hideHandler}
          />

          <CustomButton
            style={{
              padding: "10px 30px",
              height: "36px",
            }}
            title="Apply"
            onClick={submitHandler}
          />
        </Box>
      }
    >
      <Grid
        container
        spacing={2}
        alignItems="center"
        sx={{
          marginTop: 3,
          padding: "0px 8px",
        }}
      >
        {SITE_FILTER_FIELDS.map((field) => (
          <Grid item xs={6} key={field.id}>
            <FormField
              onPaste={(e: React.ClipboardEvent) => e.preventDefault()}
              {...field}
              value={formData?.[field.id as keyof SiteFilterData] || ""}
              onChange={onChangeAction}
              isNonMarginTop
              inSingleGridForm
              InputProps={{
                sx: {
                  padding: "10px 4px",
                  height: "36px",
                },
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Popup>
  );
};

export default ManageSiteFilter;